import { createApi } from "@reduxjs/toolkit/query/react";

import { REQUEST_METHODS } from "@/constants/global-constants";
import { TWeighBridge } from "@/interfaces/wastetype.interface";
import { BaseWithAuth, getWorkspace } from "@/utils/helpers";

export const weighBridgeApi = createApi({
  reducerPath: "weighBridgeApi",
  baseQuery: BaseWithAuth(),
  tagTypes: ["weighBridge", "single-weighBridge"],
  endpoints: (builder) => ({
    getWeighBridge: builder.query<GeneralResponse<TWeighBridge[]>, string>({
      query: (filter) =>
        `workspace/${getWorkspace()}/waste-management/weighbridge${filter ? filter : ""}`,
      providesTags: ["weighBridge"],
    }),

    getWeighBridgeById: builder.query<TWeighBridge, string>({
      query: (id) =>
        `workspace/${getWorkspace()}/waste-management/weighbridge/${id}`,
      transformResponse: (response: APIResponse<TWeighBridge>) =>
        response?.data,
      providesTags: ["single-weighBridge"],
    }),
    deleteWeighBridge: builder.mutation<object, string>({
      query: (id) => ({
        url: `workspace/${getWorkspace()}/waste-management/weighbridge/${id}`,
        method: REQUEST_METHODS.DELETE,
      }),
      invalidatesTags: ["weighBridge"],
    }),

    createWeighBridge: builder.mutation<object, { data: object }>({
      query: ({ data }) => ({
        url: `workspace/${getWorkspace()}/waste-management/weighbridge`,
        method: REQUEST_METHODS.POST,
        body: data,
      }),
      invalidatesTags: ["weighBridge"],
    }),

    alterWeighBridge: builder.mutation<object, { id: string; data: object }>({
      query: ({ id, data }) => ({
        url: `workspace/${getWorkspace()}/waste-management/weighbridge/${id}`,
        method: REQUEST_METHODS.PUT,
        body: data,
      }),
      invalidatesTags: ["weighBridge", "single-weighBridge"],
    }),

    alterWeighBrideStatus: builder.mutation<
      object,
      { id: string; status: string }
    >({
      query: ({ id, status }) => ({
        url: `workspace/${getWorkspace()}/waste-management/weighbridge/${id}/${status}`,
        method: "PATCH",
      }),
      invalidatesTags: ["weighBridge"],
    }),

    moveWeighBridge: builder.mutation<object, { id: string; data: object }>({
      query: ({ id, data }) => ({
        url: `workspace/${getWorkspace()}/waste-management/weighbridge/${id}/move`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["weighBridge"], //TODO:use dispatch to invalidate weighsale
    }),
  }),
});

export const {
  useGetWeighBridgeQuery,
  useCreateWeighBridgeMutation,
  useGetWeighBridgeByIdQuery,
  useDeleteWeighBridgeMutation,
  useAlterWeighBridgeMutation,
  useAlterWeighBrideStatusMutation,
  useMoveWeighBridgeMutation,
} = weighBridgeApi;
